import Axios from 'axios'
import API from './resources'

export default {
  // user
  register (data) {
    return Axios.post(API.register, data)
  },
  getVerifyCode (data) {
    return Axios.post(API.getVerifyCode, data)
  },
  deregister (data) {
    return Axios.post(API.deregister, data)
  },
  login (data) {
    return Axios.post(API.login, data)
  },
  identify (data) {
    return Axios.post(API.identify, data)
  },
  getUser (data) {
    return Axios.post(API.getUser, data)
  },  
  changePassword (data) {
    return Axios.post(API.changePassword, data)
  },
  resetPassword (data) {
    return Axios.post(API.resetPassword, data)
  },
  changeEmail (data) {
    return Axios.post(API.changeEmail, data)
  },
  logout (data) {
    return Axios.post(API.logout, data)
  },
  checkUserExist (data) {
    return Axios.post(API.checkUserExist, data)
  },
  // project
  createProject (data) {
    return Axios.post(API.createProject, data)
  },
  modifyProject (data) {
    return Axios.post(API.modifyProject, data)
  },
  deleteProject (data) {
    return Axios.post(API.deleteProject, data)
  },
  getProjects (data) {
    return Axios.post(API.getProjects, data)
  },
  getEndpoints (data) {
    return Axios.post(API.getEndpoints, data)
  },
  checkProjectExist (data) {
    return Axios.post(API.checkProjectExist, data)
  },  
  // analytic
  timeSeries (data) {
    return Axios.post(API.timeSeries, data)
  },
  topn (data) {
    return Axios.post(API.topn, data)
  },
  // management
  getTotalCount (data) {
    return Axios.post(API.getTotalCount, data)
  },
  getUsers (data) {
    return Axios.post(API.getUsers, data)
  },
  search (data) {
    return Axios.post(API.search, data)
  },
  setUser (data) {
    return Axios.post(API.setUser, data)
  },
  setProject (data) {
    return Axios.post(API.setProject, data)
  }
}



// WEBPACK FOOTER //
// ./src/api/api.js